// @flow
import React from "react";
import type {translate} from "../../../i18next";
import "./OrderFinished.scss";
import {toast} from "react-toastify";

type OrderFinishedProps = {
    t: translate,
    paymentAuthorizationFailed: boolean,
    clearOrderDetails: () => void,
	makeCartEmpty: () => void,
    goToStartpage: () => void,
};

class OrderFinished extends React.Component<OrderFinishedProps> {

    componentDidUpdate(prevProps, _prevState, _snapshot) {
        if (this.props.paymentAuthorizationFailed && !prevProps.paymentAuthorizationFailed) {
            toast.error(this.props.t("cart.paymentApiError"));
        }
    }

    componentWillUnmount() {
        this.props.clearOrderDetails();
        this.props.makeCartEmpty();
	}

	render() {
		return (
			<React.Fragment>
                <div className="hpm-orderFinished hpm-emptyCart">
                    <div>
                        <span className={"hpm-orderFinish"}>{this.props.t("cart.finished")}</span>
                        <button
                            type={"button"}
                            onClick={() => this.props.goToStartpage()}
                            className="hpm-cartButton back">{this.props.t("cart.back")}
                        </button>
                    </div>
                </div>
			</React.Fragment>
		);
	}
}

export default OrderFinished;
